<input [class.light-design]="isListBoardStyle" (click)="onClick()" [value]="formattedValue$ | async" [disabled]="disabled" [placeholder]="showPlaceholder ? (placeholder || outputFormat) : ''" readonly />
<div class="clear_btn" *ngIf="isClearBtnVisible" tabindex="0" (click)="onClear()"></div>
